import React, { Component } from "react"
import Button from "@material-ui/core/Button"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import { Link } from "react-router-dom"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
import Container from "@material-ui/core/Container"
import { withStyles } from "@material-ui/core"
import { Cookies } from "react-cookie"
import { Alert, AlertTitle } from "@material-ui/lab"
import { Redirect } from "react-router-dom"
import Paper from "@material-ui/core/Paper"
import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell from "@material-ui/core/TableCell"
import TableContainer from "@material-ui/core/TableContainer"
import TableHead from "@material-ui/core/TableHead"
import TablePagination from "@material-ui/core/TablePagination"
import TableRow from "@material-ui/core/TableRow"
import JDate from "jalali-date"
import Switch from "@material-ui/core/Switch"
import Snackbar from "@material-ui/core/Snackbar"
import * as constants from "../constants"
import Divider from "@material-ui/core/Divider"
import TableSortLabel from "@material-ui/core/TableSortLabel"
import Moment from "moment"
import NumberFormat from "react-number-format"
import HighlightOffIcon from "@material-ui/icons/HighlightOff"

import Collapse from "@material-ui/core/Collapse"
import Avatar from "@material-ui/core/Avatar"

import "react-modern-calendar-datepicker/lib/DatePicker.css"
import Calendar from "react-modern-calendar-datepicker"
import OutlinedInput from "@material-ui/core/OutlinedInput"
import IconButton from "@material-ui/core/IconButton"
import InputAdornment from "@material-ui/core/InputAdornment"
import FloatingLabelInput from "./FloatingLabelInput"
import Fab from "@material-ui/core/Fab"
import VoiceOverOffIcon from "@material-ui/icons/VoiceOverOff"
import RecordVoiceOverIcon from "@material-ui/icons/RecordVoiceOver"
import CloseIcon from "@material-ui/icons/Close"
import CheckIcon from "@material-ui/icons/Check"
import Select from "react-select"

import ImageUploader from "react-images-upload"
import LinearProgress from "@material-ui/core/LinearProgress"

import { Lightbox } from "react-modal-image"
import Dialog from "@material-ui/core/Dialog"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import DialogContentText from "@material-ui/core/DialogContentText"
import DialogTitle from "@material-ui/core/DialogTitle"

const styles = (theme) => ({
      paperrtl: {
            marginTop: theme.spacing(0),
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
      },
      paper: {
            display: "flex",
            flexWrap: "wrap",
            "& > *": {
                  margin: theme.spacing(1),
                  width: theme.spacing(20),
            },
      },
      root: {
            width: "100%",
            margin: "15px",
            padding: "8px",
            direction: "rtl",
      },
      container: {
            maxHeight: 400,
      },
      large: {
            width: theme.spacing(10),
            height: theme.spacing(10),
      },
      small: {
            width: theme.spacing(6),
            height: theme.spacing(6),
      },
})

class ChangeRequestQuestion extends Component {
      cookies = new Cookies()
      temp333
      constructor(props) {
            super(props)
            this.state = {
                  redirect: false,
                  errstr: "",
                  errstatus: false,
                  okstatus: false,
                  requestinfos: [],
                  agentInfofilter: [],
                  rowsPerPage: 10,
                  page: 0,
                  request_question_id: "",
                  request_question_name: "",
                  selectedFieldinsurance: "",
                  selectedTimeanswer_complaints: "",
                  selectedCustomer_satisfaction: "",
                  selectedNum_branchesdamages: "",

                  request_question_desc: "",
                  orderBy: "request_question_id",
                  order: "desc",
                  snackstr: "",
                  showSnack: false,
                  snackMode: "success",
                  newRequestQuestion: true,
                  loading: false,
                  percent: 0,
                  optionFieldinsurance: [],
                  request_question_active: "0",

                  urlToLargeImageFile: "",
                  urlToHugeImageFile: "",
                  descImageFile: "",
                  openImageBox: false,
                  openDialog: false,
            }
      }

      handleClickOpen = () => {
            this.setState({
                  openDialog: true,
            })
      }

      handleClose = () => {
            this.setState({
                  openDialog: false,
            })
      }



      closeLightbox = () => {
            this.setState({
                  openImageBox: false,
            })
      }

      handleChangeRequestQuestionName = (event) => {
            this.setState({ request_question_name: event.target.value })
      }



      handleChangeRequestQuestionDesc = (event) => {
            this.setState({ request_question_desc: event.target.value })
      }

      handleLevelof_prosperity = (selectedFieldinsurance) => {
            this.setState({ selectedFieldinsurance: selectedFieldinsurance }, () => {
                  this.filterManagDiscount()
            })
      }

      handleClickcloseTasckBar = (event) => {
            this.setState({ showSnack: false })
      }

      handleChangeDeactive = (event) => {
            if (event.target.checked) {
                  this.setState({ request_question_active: "1" })
            } else {
                  this.setState({ request_question_active: "0" })
            }
      }

      handleSelectRows = (row2) => {
            this.setState(
                {
                      request_question_id: row2.request_question_id,
                      request_question_name: row2.request_question_name,
                      selectedFieldinsurance: { value: row2.request_question_fieldinsurance, label: row2.fieldinsurance_fa },
                      request_question_desc: row2.request_question_desc,
                      request_question_active: row2.request_question_active,
                      newRequestQuestion: false,
                },
                () => {}
            )
      }

      newRequestQuestion = (event) => {
            this.setState(
                {
                      request_question_id: "",
                      request_question_name: "",
                      //  selectedFieldinsurance:optionFieldinsurance[0],
                      request_question_active: "0",
                      request_question_desc: "",
                      newRequestQuestion: true,
                },
                () => {}
            )
      }
      componentDidMount() {
            if (this.cookies.get("employee_token_str")) {
                  this.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.getRequestQuestion()
                                    self.getoptionFieldinsurance()
                              } else if (arr.result === "error") {
                                    self.setState({ redirect: true })
                              }
                              self.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "checkemployeelogin")

                  xhttp.open("POST", `${constants.BASE_URL}/employeelogin`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ redirect: true })
            }
      }

      getoptionFieldinsurance = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].fieldinsurance, label: arr.data[k].fieldinsurance_fa })
                              }
                              self.setState({ optionFieldinsurance: Company, selectedFieldinsurance: Company[0] }, () => {
                                    self.filterManagDiscount()
                              })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_fieldinsurance")
            xhttp.open("POST", `${constants.BASE_URL}/fieldinsurance`)
            xhttp.send(fd)
      }

      getRequestQuestion() {
            this.props.props.dispatch({
                  type: "WAITSHOW",
            })
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ requestinfos: arr.data, agentInfofilter: arr.data }, () => {
                                    self.filterManagDiscount()
                                    self.newRequestQuestion()
                              })
                        } else if (arr.result === "error") {
                        }
                        self.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_requestquestion")

            xhttp.open("POST", `${constants.BASE_URL}/requestquestion`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      saveNewRequestQuestion = () => {
            const { request_question_id, request_question_name, selectedFieldinsurance, request_question_desc, request_question_active } = this.state
            this.props.props.dispatch({
                  type: "WAITSHOW",
            })

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                              //self.setState({ redirect: true })
                              self.getRequestQuestion()
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                        self.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "add_requestquestion")
            fd.append("request_question_name", request_question_name)
            fd.append("request_question_fieldinsurance", selectedFieldinsurance.value)
            fd.append("request_question_desc", request_question_desc)
            fd.append("request_question_active", request_question_active)
            xhttp.open("POST", `${constants.BASE_URL}/requestquestion`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      changeRequestQuestion = () => {
            const { request_question_id, request_question_name, selectedFieldinsurance, request_question_desc, request_question_active } = this.state
            this.props.props.dispatch({
                  type: "WAITSHOW",
            })

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                              //self.setState({ redirect: true })
                              self.getRequestQuestion()
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                        self.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "modify_requestquestion")
            fd.append("request_question_id", request_question_id)
            fd.append("request_question_name", request_question_name)
            fd.append("request_question_fieldinsurance", selectedFieldinsurance.value)
            fd.append("request_question_desc", request_question_desc)
            fd.append("request_question_active", request_question_active)


            xhttp.open("POST", `${constants.BASE_URL}/requestquestion`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      deleteImageRequire = () => {
            const { request_question_id } = this.state
            this.props.props.dispatch({
                  type: "WAITSHOW",
            })
            this.handleClose()
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                              //self.setState({ redirect: true })
                              self.getRequestQuestion()
                              self.newRequestQuestion()
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                        self.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "delete_requestquestion")
            fd.append("request_question_id", request_question_id)

            xhttp.open("POST", `${constants.BASE_URL}/requestquestion`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      createSortHandler = (field) => {
            if (this.state.orderBy === field) {
                  if (this.state.order === "asc") {
                        this.setState({ order: "desc" })
                  } else {
                        this.setState({ order: "asc" })
                  }
            } else {
                  this.setState({ orderBy: field, order: "asc" })
            }
            var arraytemp = [],
                i,
                j,
                temp,
                a,
                b
            arraytemp = this.state.agentInfofilter
            for (i = 0; i < arraytemp.length; i++) {
                  for (j = 0; j < arraytemp.length - 1; j++) {
                        a = arraytemp[j]
                        b = arraytemp[j + 1]
                        if (a[field] < b[field] && this.state.order === "asc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        } else if (a[field] > b[field] && this.state.order === "desc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        }
                  }
            }
      }

      handleChangeRowsPerPage = (event) => {
            this.setState({ rowsPerPage: parseInt(event.target.value), page: 0 })
      }

      handleChangePage = (event, number) => {
            this.setState({ page: parseInt(number, 0) })
      }

      filterManagDiscount = () => {
            const { selectedFieldinsurance, requestinfos } = this.state
            var temparray = requestinfos,
                temparray2 = [],
                i
            for (i = 0; i < temparray.length; i++) {
                  if (temparray[i].request_question_fieldinsurance === selectedFieldinsurance.value) {
                        temparray2.push(temparray[i])
                  }
            }
            this.setState({ agentInfofilter: temparray2 }, () => {})
      }

      render() {
            const { classes } = this.props
            const {
                  urlToHugeImageFile,
                  request_question_active,
                  descImageFile,
                  urlToLargeImageFile,
                  optionFieldinsurance,
                  selectedFieldinsurance,
                  loading,
                  percent,
                  selectedNum_branchesdamages,
                  selectedCustomer_satisfaction,
                  agentPermision,
                  snackMode,
                  snackstr,
                  showSnack,
                  newRequestQuestion,
                  request_question_id,
                  request_question_name,
                  request_question_desc,
                  order,
                  orderBy,
                  okstatus,
                  errstr,
                  redirect,
                  agentInfofilter,
                  rowsPerPage,
                  page,
            } = this.state
            if (redirect) {
                  return <Redirect to="/" />
            } else {
                  return (
                      <div className={classes.paperrtl} dir="ltr">
                            <Snackbar
                                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                onClose={this.handleClickcloseTasckBar}
                                open={showSnack}
                                autoHideDuration={10000}
                            >
                                  <Alert severity={snackMode}>{snackstr}</Alert>
                            </Snackbar>
                            <Grid container spacing={3}>
                                  <Grid item xs={12}>
                                        <Container component="main" maxWidth="lg">
                                              <Paper elevation={4} className={classes.root}>
                                                    <Grid container spacing={3}>
                                                          <Grid item xs={6}>
                                                                <Typography align="center" variant="h7">
                                                                      {"آی دی سوال" + request_question_id}
                                                                </Typography>
                                                          </Grid>

                                                          <Grid item xs={6}>
                                                                <div style={{ width: "100%", textAlign: "center" }}>

                                                                </div>
                                                          </Grid>

                                                          <Grid item xs={4}>
                                                                <FloatingLabelInput
                                                                    placeholder="نام سوال"
                                                                    handleInputt={this.handleChangeRequestQuestionName}
                                                                    value={request_question_name}
                                                                />
                                                          </Grid>

                                                          <Grid item xs={4}>
                                                                <div>
                                                                      <label className="on">{"رشته بیمه"} </label>
                                                                      <Select
                                                                          isSearchable={true}
                                                                          className="adapter-txtsize"
                                                                          placeholder={"رشته بیمه"}
                                                                          value={selectedFieldinsurance}
                                                                          onChange={this.handleLevelof_prosperity}
                                                                          options={optionFieldinsurance}
                                                                      />
                                                                </div>
                                                          </Grid>

                                                          <Grid item xs={4}>
                                                                <div style={{ width: "100%", textAlign: "center" }}>
                                                                      <FormControlLabel
                                                                          control={
                                                                                <Switch
                                                                                    checked={request_question_active === "1" ? true : false}
                                                                                    onChange={this.handleChangeDeactive}
                                                                                    name="gilad"
                                                                                />
                                                                          }
                                                                          label="اجباری بودن سوال"
                                                                      />
                                                                </div>
                                                          </Grid>

                                                          <Grid item xs={12}>
                                                                <FloatingLabelInput
                                                                    placeholder="توضیحات سوال"
                                                                    handleInputt={this.handleChangeRequestQuestionDesc}
                                                                    value={request_question_desc}
                                                                />
                                                          </Grid>

                                                          <Grid item xs={6}>

                                                          </Grid>
                                                          <Grid item xs={12}>
                                                                {loading && <LinearProgress variant="determinate" value={percent} />}
                                                          </Grid>

                                                          <Grid item xs={12}>
                                                                {newRequestQuestion ? (
                                                                    <Button
                                                                        variant="outlined"
                                                                        color="primary"
                                                                        onClick={(e) => {
                                                                              this.saveNewRequestQuestion()
                                                                        }}
                                                                    >
                                                                          {"ثبت سوال جدید "}
                                                                    </Button>
                                                                ) : (
                                                                    <div style={{ width: "100%", textAlign: "right" }}>
                                                                          <Button
                                                                              variant="outlined"
                                                                              color="primary"
                                                                              onClick={this.newRequestQuestion}
                                                                          >
                                                                                {"سوال جدید"}
                                                                          </Button>
                                                                          {"          "}
                                                                          <Button
                                                                              variant="outlined"
                                                                              color="primary"
                                                                              onClick={(e) => {
                                                                                    this.changeRequestQuestion()
                                                                              }}
                                                                          >
                                                                                {"ثبت تغییرات"}
                                                                          </Button>

                                                                          {"          "}
                                                                          <Button
                                                                              variant="outlined"
                                                                              color="primary"
                                                                              onClick={(e) => {
                                                                                    this.handleClickOpen()
                                                                              }}
                                                                          >
                                                                                {"حذف سوال مورد نیاز "}
                                                                          </Button>
                                                                    </div>
                                                                )}
                                                          </Grid>

                                                          <Grid item xs={12}>
                                                                <Divider />
                                                          </Grid>
                                                    </Grid>
                                              </Paper>
                                        </Container>
                                  </Grid>
                                  <Grid item xs={12}>
                                        <Container maxWidth="lg">
                                              <Paper className={classes.root}>
                                                    <TableContainer dir="rtl">
                                                          <Table aria-label="sticky table">
                                                                <TableHead>
                                                                      <TableRow>
                                                                            <TableCell></TableCell>

                                                                            <TableCell
                                                                                key={"fieldinsurance_fa"}
                                                                                align={"center"}
                                                                                style={{ minWidth: 20 }}
                                                                                sortDirection={orderBy === "fieldinsurance_fa" ? order : false}
                                                                            >
                                                                                  {"نام رشته"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "fieldinsurance_fa"}
                                                                                      direction={orderBy === "fieldinsurance_fa" ? order : "asc"}
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("fieldinsurance_fa")
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"request_question_name"}
                                                                                align={"center"}
                                                                                style={{ minWidth: 60 }}
                                                                            >
                                                                                  {"نام سوال"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "request_question_name"}
                                                                                      direction={
                                                                                            orderBy === "request_question_name" ? order : "asc"
                                                                                      }
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("request_question_name")
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"request_question_desc"}
                                                                                align={"center"}
                                                                                style={{ minWidth: 60 }}
                                                                            >
                                                                                  {" توضیحات سوال"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "request_question_desc"}
                                                                                      direction={
                                                                                            orderBy === "request_question_desc" ? order : "asc"
                                                                                      }
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("request_question_desc")
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>
                                                                            <TableCell
                                                                                key={"request_question_active"}
                                                                                align={"center"}
                                                                                style={{ minWidth: 20 }}
                                                                            >
                                                                                  {"اجباری بودن سوال"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "request_question_active"}
                                                                                      direction={
                                                                                            orderBy === "request_question_active" ? order : "asc"
                                                                                      }
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("request_question_active")
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>
                                                                      </TableRow>
                                                                </TableHead>

                                                                <TableBody>
                                                                      {agentInfofilter
                                                                          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                                          .map((row) => {
                                                                                return (
                                                                                    <TableRow
                                                                                        hover
                                                                                        role="checkbox"
                                                                                        tabIndex={-1}
                                                                                        key={row["request_question_id"]}
                                                                                        value={row}
                                                                                        onClick={() => {
                                                                                              this.handleSelectRows(row)
                                                                                        }}
                                                                                    >
                                                                                          <TableCell>

                                                                                          </TableCell>
                                                                                          <TableCell key={"fieldinsurance_fa"} align={"center"}>
                                                                                                {row["fieldinsurance_fa"]}
                                                                                          </TableCell>

                                                                                          <TableCell
                                                                                              key={"request_question_name"}
                                                                                              align={"center"}
                                                                                          >
                                                                                                {row["request_question_name"]}
                                                                                          </TableCell>

                                                                                          <TableCell
                                                                                              key={"request_question_desc"}
                                                                                              align={"center"}
                                                                                          >
                                                                                                {row["request_question_desc"]}
                                                                                          </TableCell>

                                                                                          <TableCell
                                                                                              key={"request_question_active"}
                                                                                              align={"center"}
                                                                                          >
                                                                                                {row["request_question_active"] === "0" ||
                                                                                                row["request_question_active"] === 0 ? (
                                                                                                    <Fab variant="extended">
                                                                                                          <VoiceOverOffIcon />
                                                                                                          {"غیر فعال"}
                                                                                                    </Fab>
                                                                                                ) : (
                                                                                                    <Fab
                                                                                                        variant="extended"
                                                                                                        style={{ background: "#44b700" }}
                                                                                                    >
                                                                                                          <RecordVoiceOverIcon />
                                                                                                          {"فعال"}
                                                                                                    </Fab>
                                                                                                )}
                                                                                          </TableCell>
                                                                                    </TableRow>
                                                                                )
                                                                          })}
                                                                </TableBody>
                                                          </Table>
                                                    </TableContainer>
                                                    <TablePagination
                                                        rowsPerPageOptions={[10, 25, 100]}
                                                        component="div"
                                                        count={agentInfofilter.length}
                                                        rowsPerPage={rowsPerPage}
                                                        page={page}
                                                        onChangePage={this.handleChangePage}
                                                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                                    />
                                              </Paper>
                                        </Container>
                                  </Grid>
                            </Grid>

                            {okstatus ? (
                                <Alert severity="success">
                                      <AlertTitle>پیام</AlertTitle>
                                      {errstr}
                                </Alert>
                            ) : null}

                            {this.state.openImageBox && (
                                <Lightbox
                                    medium={urlToLargeImageFile}
                                    large={urlToHugeImageFile}
                                    alt={descImageFile}
                                    onClose={this.closeLightbox}
                                    showRotate={true}
                                    hideZoom={false}
                                />
                            )}

                            <Dialog
                                open={this.state.openDialog}
                                onClose={this.handleClose}
                                aria-labelledby="alert-dialog-title"
                                aria-describedby="alert-dialog-description"
                            >
                                  <DialogTitle id="alert-dialog-title">{"آیا میخواهید سوال مورد نیاز را پاک نمایید"}</DialogTitle>
                                  <DialogContent>
                                        <DialogContentText id="alert-dialog-description">
                                              ابتدا از عملیات خود مطمئن شوید و سپس پاک کنید
                                        </DialogContentText>
                                  </DialogContent>
                                  <DialogActions>
                                        <Button onClick={this.handleClose} color="primary">
                                              انصراف
                                        </Button>
                                        <Button onClick={this.deleteImageRequire} color="primary" autoFocus>
                                              بله انجام شود
                                        </Button>
                                  </DialogActions>
                            </Dialog>
                      </div>
                  )
            }
      }
}

export default withStyles(styles)(ChangeRequestQuestion)
